import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { useCrossBrowserContext } from 'hooks/useCrossBrowserContext';
import { FC } from 'react';

import type { ShareButtonProps } from './ShareButton.connect';

export const RawShareButton: FC<ShareButtonProps> = ({ onShare, color: status, isDisabled }) => {
  const { isDirty, isLocked } = useCrossBrowserContext();
  const isCrossBrowserFrozen = isDirty || isLocked;
  const isShareDisabled = isDisabled || isCrossBrowserFrozen;
  return (
    <button
      data-e2e="open-product-summary"
      type="button"
      className={classNames('btn btn-sm btn-icon-end p-2 me-2', {
        'btn-flat-primary': status === 'ready',
        'btn-flat-info': status === 'tradable',
        'btn-flat-success': status === 'indicative',
        'btn-flat-warning': status === 'previous' || status === 'pending',
        'btn-flat-danger': status === 'nontradable',
      })}
      style={{
        color:
          status === 'secondaryquotedclientsell' ? '#f576bb' : status === 'secondaryquotedclientbuy' ? '#26d1d3' : '',
      }}
      onClick={onShare}
      disabled={isShareDisabled}
    >
      <FormattedMessage id="form.buttons.Share" />
      <i className="icon">share</i>
    </button>
  );
};

RawShareButton.displayName = 'RawShareButton';
